<template>
	<div>
		<el-card class="userMeetingList">
			<div class="meeting-search">
				<el-form :inline="true" :model="searchForm" class="demo-form-inline">
					<el-form-item label="案号" style="margin-right: 50px">
						<el-input v-model="searchForm.subject" clearable></el-input>
					</el-form-item>
					<el-form-item label="会议名称" style="margin-right: 50px">
						<el-input v-model="searchForm.name" clearable></el-input>
					</el-form-item>
					<el-form-item label="会议状态">
						<el-select v-model="status" placeholder="请选择状态">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="el-form-right-1">
						<!-- style="background: #de4d2a !important" -->
						<el-button icon="el-icon-search" type="primary" @click="onSubmit">查询
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-row class="table-meeing" :gutter="24">
				<el-table align="center" :data="tableData" size="medium" v-loading="loading" :height="userInfo.type !== 'MANAGER' ?'55vh':'69.7vh'">
					<el-table-column align="center" prop="subject" label="案号"></el-table-column>
					<el-table-column align="center" prop="name" label="会议名称"> </el-table-column>
					<el-table-column align="center" prop="startTime" label="会议日期">
						<template slot-scope="scope">
							{{ timeConvert(scope.row.startTime) }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sponsor" label="发起人"> </el-table-column>
					<el-table-column v-if="userInfo.type === 'MANAGER'" align="center" prop="participantNum"
						label="参会人数">
						<template slot-scope="scope">
							{{ scope.row.participantNum ? scope.row.participantNum : 0 }}
						</template></el-table-column>
					<el-table-column align="center" prop="state" label="会议状态">
						<template slot-scope="scope">
							{{
                            scope.row.state === 'NOT_STARTED'
                            ? '未开始'
                            : scope.row.state === 'ONGOING'
                            ? '进行中'
                            : scope.row.state === 'TESTING'
                            ? '测试中'
                            : scope.row.state === 'ENDED'
                            ? '已结束'
                            : ''
                            }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作列">
						<template slot-scope="scope">
							<div class="operations">
								<el-button size="medium" type="text" @click="liveMeeting(scope.row)">会议直播</el-button>
								<el-button style="margin-left: 15px;" v-if="userInfo.type === 'MANAGER'" size="medium"
									type="text"
									@click="openPersonManagers(scope.row.id, scope.row.name, 0, 'first',scope.row)">进入会议</el-button>
								<!-- enterMeeting(scope.row) -->

							</div>
						</template>
					</el-table-column>
				</el-table>
			</el-row>
			<el-row :gutter="24">
				<Pagination customClass="alone" :total="total" @handleSizeChange="turnPage"
					@handleCurrentChange="turnPage" />
			</el-row>
		</el-card>
		<div class="img-wrapper" v-if="userInfo.type !== 'MANAGER'">
            <img src="../../../../assets/img/banner.png" mode="aspectFit" alt="">
            <div class="banner-btn" @click="bannerClick"></div>
        </div>
		<el-dialog title="" :close-on-click-modal="false" :visible.sync="liveDialogVisible" width="610px" center
			:before-close="cancelClose" top="15vh">
			<div class="" slot="title"
				style="text-align: center;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;b">
				会议须知
			</div>
			<div class="agreement">
				<div class="" style="position: absolute;width: 100%;top: -20px;border-top: 1px solid #F0F0F0;">

				</div>
				<p>&emsp;&emsp;为提高债权人参会效率，本次会议根据《最高人民法院关于适用〈中华人民共和国企业破产法〉若干问题的规定（三）》第十一条规定，特依法采取网络形式召开。现将本次会议须知说明如下：</p>
				<!-- <h3 class="title tips">一. 网上债权人会议的法律声明</h3> -->
				<p>&emsp;&emsp;一、债权人会议是由依法申报债权的全体债权人组成的临时性机构，行使《企业破产法》规定之权利。</p>
				<p>&emsp;&emsp;二、第一次债权人会议由人民法院召集，债权人必须服从人民法院的安排和指挥，自觉维护会议秩序，有序参与各项会议议程，不得实施违反会议秩序的行为，包括但不限于：</p>
				<p>&emsp;&emsp;（一）未经法庭允许，随意发言、提问；</p>
				<p>&emsp;&emsp;（二）发表与案件无关的文字、音频、视频和图片等；</p>
				<p>&emsp;&emsp;（三）未经许可录音、录像、截屏、拍照等；</p>
				<p>&emsp;&emsp;（四）将会议相关材料（包括且不限于在债权人会议平台上所形成的，与会议相关的文字、音频、视频、图片等）外传、扩散、转发他人，或用于与案件无关的其他任何用途。</p>
				<p>&emsp;&emsp;三、对违反会议纪律的，人民法院可以予以口头警告、训诫或者予以罚款、拘留；对于严重扰乱会议秩序的人，将依法追究其刑事责任。</p>
				<p>&emsp;&emsp;四、债权人对本次会议的相关事宜有疑问的，可在会议结束后向管理人咨询。</p>
				<div class="" style="padding-bottom: 10px;border-bottom: 1px solid #F0F0F0;margin-bottom: 10px;">

				</div>
			</div>
			<!-- <div class="" slot="title"
				style="text-align: center;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;b">
				参加网上会议确认书
			</div>
			<div class="agreement">
				<div class="" style="position: absolute;width: 100%;top: -20px;border-top: 1px solid #F0F0F0;">

				</div>
				<h3 class="title">尊敬的债权人会议参会人员，请您在确认网上参会时认真阅读确认书</h3>
				<h3 class="title">本确认书包含以下内容，通过确认网上参会,代表您已是同意并接受以下条款的约束:</h3>
				<h3 class="title tips">一. 网上债权人会议的法律声明</h3>
				<p>
					1.网上债权人会议同一般线下的债权人会议具有同等的法律效力，债权人会议参会人员在互联网上参与网上债权人会议，可以通过网上会议进行会议观看、表决投票等。
				</p>
				<p>2.债权人会议参会成员通过网络出席会议，破产案件审理法院和破产管理人应当认为该成员出席了本次会议。</p>
				<p>3.债权人会议参会成员通过网络参与的投票表决事项，破产案件理法院和破产管人应当认为该成员的表决票有效。</p>
				<p>4.债权人会议参会成员应由本人或其法定委托代理人自行登录进行网上参会</p>
				<h3 class="title tips">二.网上债权人会议的注意事项</h3>
				<p>1.网上债权人会议的参会人员应当本着诚实守信的原则参与网上债权人会议。</p>
				<p>2.网上债权人会议的参会人员应该按照破产管理人公布的时同登录进行网上参会。</p>
				<p>3.网上债权人会议参会时，参会人员不得在计算机上进行其他妨碍债权人会议的行为,且不应长时间离开。</p>
				<p>4.参加网上债权人会议时，应认真听取破产案件审理法院和破产管理人宣读的各项规定和各种会议决议。</p>
				<p>5.参加网上债权人会议的人员，需遵守破产案件审理法院和破产管理人的其他规定</p>
				<div class="" style="padding-bottom: 10px;border-bottom: 1px solid #F0F0F0;margin-bottom: 10px;">

				</div>
			</div> -->
			<div class="read">
				<el-checkbox v-model="checked"><span class="read-content">已读并接受以上条款( 请选)</span></el-checkbox>
			</div>
			<span class="dialog-footer">
				<!-- style="background: #de4d2a !important" -->
				<el-button style="width: 120px;" type="primary" @click="agreement" :disabled="!checked">确认参会</el-button>
			</span>
		</el-dialog>
		<!-- <Footer /> -->

		<CardAuth :meetingId="meetingId" :dialogVisible="dialogVisible" @close="dialogVisible = false"></CardAuth>

		<el-dialog title="参加网上会议确认书" :visible.sync="noticeDialogVisible" width="80%" top="5vh"
			:before-close="noticeCloses">
			<div class="" style="display: flex;justify-content: space-between;width: 100%;height: 80vh;">
				<div class="" style="width: 90%;height: 100%;">
					<iframe v-if="noticeImageUrl == ''" ref="pdf" src="https://file.pochanyun.com/url/live.pdf"
						width="100%" height="100%"></iframe>
					<iframe v-if="noticeImageUrl !=''" ref="pdf" :src="noticeImageUrl" width="100%"
						height="100%"></iframe>
				</div>
				<div class="" style="height: 100%;display: flex;width: 10%;align-items: flex-end;">
					<div v-if="noticeImageUrl == ''" class="" style="width: 100%;display: flex;justify-content: center;">
						<div class="">
							<el-button size="medium" style="width: 98px;height: 36px;" type="primary" @click="signatureDialogVisible = true">签名</el-button>
						</div>
					</div>
					<div v-if="noticeImageUrl != ''" class="" style="width: 1000%;display: flex;justify-content: center;">
						<div class="">
							<div class="">
								<el-button size="medium" style="width: 98px;height: 36px;" @click="signatureDialogVisible = true">重新签名</el-button>
							</div>
							<div class="" style="margin-top: 20px;">
								<el-button size="medium" style="width: 98px;height: 36px;" type="primary" @click="confirmSign">确认签名</el-button>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</el-dialog>
		<el-dialog title="参加网上会议确认书" :visible.sync="signatureDialogVisible" width="80%" top="5vh"
			:before-close="handleCloses">
			<div class="" style="display: flex;align-items: center;justify-content: center;width: 100%;">
				<signature @handleClose="handleCloses" style="" @succeed="signatureSucceed"
					:noticeDialogVisibleRow="noticeDialogVisibleRow"></signature>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Footer from '@/components/layout/Footer';
	import moment from 'moment';
	import {
		mapState
	} from 'vuex';
	import Pagination from '@/components/Pagination';
	import {
		getUserSign,
		setUserSign,
		setTestSign,
		getMeetingConfirmSign
	} from '@/serve/sign';
	import {
		gatheringMeetingAuth
	} from '@/serve/live';
	import CardAuth from '../cardAuth.vue'
	import signature from "./signature.vue";
	import global from 'global';
	export default {
		components: {
			Pagination,
			Footer,
			CardAuth,
			signature
		},
		props: {
			searchForm: Object,
			tableData: Array,
			loading: Boolean,
			total: Number
		},
		data() {
			return {
				noticeDialogVisibleRow: '',
				noticeDialogVisible: false,
				noticeImageUrl: '',
				signId: '',
				signatureDialogVisible: false,
				meetingId: '',
				dialogVisible: false,
				checked: true,
				meetingInfo: {},
				liveDialogVisible: false,
				status: '',
				isStatus: '',
				options: [{
						label: '全部',
						value: ''
					},
					{
						label: '未开始',
						value: 'noStart'
					},
					{
						label: '进行中',
						value: 'began'
					},
					{
						label: '测试中',
						value: 'test'
					},
					{
						label: '已结束',
						value: 'ended'
					}
				],
				row:'',
			};
		},
		computed: {
			...mapState({
				userInfo: (state) => state.user.userInfo
			})
		},
		methods: {
			handleCloses() {
				this.signatureDialogVisible = false;
			},
			signatureSucceed(id) {
				this.signId = id;
				// let url = `https://live.pochanyun.net/api/sys/fs/${id}?d=false`;
				let url = `/api/sys/fs/${id}?d=false`;

				this.noticeImageUrl = url;
				this.signatureDialogVisible = false;
				// this.startDeclarationClick();
			},
			confirmSign() {
				let that = this
				this.$confirm('确认签名是否正确,一旦签名成功，无法撤销', '签名确认', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					getMeetingConfirmSign(that.noticeDialogVisibleRow.id, that.signId).then((res) => {
						console.log("res", res);
						that.$message({
							message: '签字已确认',
							type: 'success'
						});
						that.noticeCloses();
						that.liveMeeting(that.noticeDialogVisibleRow);
						if (
							(this.row.state === 'ONGOING' && (this.userInfo.type == 'CREDITOR' || this.userInfo.type ==
								'AGENT')) ||
							(this.row.state === 'TESTING' && (this.userInfo.type == 'CREDITOR' || this.userInfo.type ==
								'AGENT'))
						) {
							this.getUserSign(this.row.id, this.row.state);
							this.checked = true;
						}
						
					});
				}).catch(() => {
					this.$message({
						showClose: true,
						message: '签名取消,请重新签名'
					});
					// this.$refs.SignCanvas.canvasClear();
				});


			},
			noticeCloses() {
				this.noticeImageUrl = '';
				this.noticeDialogVisible = false;
			},
			cancelClose() {
				// this.checked = false;
				this.liveDialogVisible = false;
			},
			setDialogVisible(type, flag = false, row) {
				this.$emit('sure', type, flag, row);
			},
			openPersonManagers(id, name, num, tab, row, isShow = true) {
				// this.setDialogVisible('goIntoDialogVisible', false, row);
				// this.$emit('enter', row, isShow);
				this.$router.push({
					path: '/enterMeeting',
					query: {
						num,
						id,
						name,
						tab,
						row,
						isShow
					}
				});
			},
			// 进入会议
			enterMeeting(row, isShow = true) {
				this.setDialogVisible('goIntoDialogVisible', false, row);
				this.$emit('enter', row, isShow);
			},
			// 获取当前用户是否签到
			getUserSign(id, status) {
				getUserSign(id)
					.then((res) => {
						console.log("用户签到：", res)
						if (status === 'ONGOING') {
							if (res.sign) {
								this.gotoLive();
								return;
							}
						} else {
							if (res.test) {
								this.gotoLive();
								return;
							}
						}
						this.isStatus = status;
						this.liveDialogVisible = true;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 同意协议
			agreement() {
				this.cancelClose();
				console.log("isStatus:", this.isStatus);
				console.log("meetingInfo:", this.meetingInfo)
				this.isStatus == 'ONGOING' ? setUserSign(this.meetingInfo.id) : setTestSign(this.meetingInfo.id);
				this.gotoLive();
			},
			async liveMeeting(row) {
				console.log("row", row)
				this.meetingInfo = row;
				let res = await getUserSign(row.id);
				let gatheringMeetingAuthType = false;
				console.log("userInfo", this.userInfo)
				this.row = row;
				await gatheringMeetingAuth({
					meeting_id: row.id,
					isPc: true
				}).then(res => {
					if (res) {
						gatheringMeetingAuthType = true;
					} else {
						gatheringMeetingAuthType = false;
					}
				})
				// 会议是否开始
				if (row.state === 'NOT_STARTED') {
					return this.$message.warning('会议未开始！');
				} else if (this.userInfo.type == 'MANAGER' || this.userInfo.type == 'ADMIN' || this.userInfo.type == 'OTHER') {
					this.gotoLive();
				} else if (row.signature && !gatheringMeetingAuthType) {
					//是否需要实名认证
					this.meetingId = row.id
					this.dialogVisible = true
					return
				} else if (!res.signFileId && row.normalSign) {
					// 需要签名
					console.log("需要签名")
					this.noticeDialogVisibleRow = row;
					this.noticeDialogVisible = true;
					return
				} else if (
					(row.state === 'ONGOING' && (this.userInfo.type == 'CREDITOR' || this.userInfo.type ==
						'AGENT')) ||
					(row.state === 'TESTING' && (this.userInfo.type == 'CREDITOR' || this.userInfo.type ==
						'AGENT'))
				) {
					this.getUserSign(row.id, row.state);
					this.checked = true;
				} else {
					this.gotoLive();
				}



				// console.log("row", row)
				// let res = await getUserSign(row.id);
				// console.log("res",res)
				// // 会议是否开始
				// if (row.state === 'NOT_STARTED') {
				// 	return this.$message.warning('会议未开始！');
				// }else if(row.signature){
				// 	//是否需要实名认证
				// 	gatheringMeetingAuth({
				// 		meeting_id: row.id,
				// 		isPc: true
				// 	}).then(res => {
				// 		console.log("res", res)
				// 		if (!res) {
				// 			// 需要实名认证
				// 			this.meetingId = row.id
				// 			this.dialogVisible = true
				// 			return
				// 		}else if(){

				// 		}
				// 		if (!res.signFileId && row.normalSign) {

				// 			// 需要签名
				// 			console.log("需要签名")
				// 			this.noticeDialogVisibleRow = row;
				// 			this.noticeDialogVisible = true;
				// 			return
				// 		}
				// 	})
				// }else if (!res.signFileId && row.normalSign) {
				// 	// 需要签名
				// 	console.log("需要签名")
				// 	this.noticeDialogVisibleRow = row;
				// 	this.noticeDialogVisible = true;
				// 	return
				// }
				// gotoLive()
				// const gotoLive = () => {
				// 	if (row.state === 'NOT_STARTED') {
				// 		return this.$message.warning('会议未开始！');
				// 	}
				// 	this.meetingInfo = row;
				// 	// 若是进行中会议则判断签到
				// 	if (
				// 		(row.state === 'ONGOING' && (this.userInfo.type == 'CREDITOR' || this.userInfo.type ==
				// 			'AGENT')) ||
				// 		(row.state === 'TESTING' && (this.userInfo.type == 'CREDITOR' || this.userInfo.type ==
				// 			'AGENT'))
				// 	) {
				// 		this.getUserSign(row.id, row.state);
				// 		this.checked = true;
				// 	} else {
				// 		this.gotoLive();
				// 	}
				// }
				// if (!row.signature) {
				// 	gotoLive()
				// 	return
				// }
				// // gotoLive()
				// gatheringMeetingAuth({
				// 	meeting_id: row.id,
				// 	isPc: true
				// }).then(res => {
				// 	console.log("res", res)
				// 	if (!res) {
				// 		this.meetingId = row.id
				// 		this.dialogVisible = true
				// 		return
				// 	}
				// 	gotoLive()
				// })

			},
			// 进入会议直播
			gotoLive() {
				this.$router.push({
					path: '/liveBroadcast',
					query: {
						name: this.meetingInfo.name,
						id: this.meetingInfo.id
					}
				});
			},
			// 翻页
			turnPage(attr, val) {
				this.searchForm[attr] = val;
				this.$emit('search', this.searchForm);
			},
			// 查询列表
			onSubmit() {
				switch (this.status) {
					case '':
						this.searchForm.began = null;
						this.searchForm.ended = null;
						this.searchForm.test = null;
						break;
					case 'noStart':
						this.searchForm.began = false;
						this.searchForm.ended = false;
						this.searchForm.test = false;
						break;
					case 'began':
						this.searchForm.began = true;
						this.searchForm.ended = false;
						this.searchForm.test = false;
						break;
					case 'test':
						this.searchForm.began = false;
						this.searchForm.ended = false;
						this.searchForm.test = true;
						break;
					case 'ended':
						this.searchForm.began = true;
						this.searchForm.ended = true;
						this.searchForm.test = false;
						break;
					default:
						break;
				}
				this.$emit('search', this.searchForm);
			},
			// 时间格式化
			timeConvert(timestamp) {
				return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
			},
			bannerClick() {
				/**升级正式环境时需更换域名 */
				/**升级正式环境时需更换域名 */
				/**升级正式环境时需更换域名 */
				// location.href = 'https://declare.pochanyun.net/common/advertising';
				location.href = 'https://www.pochanyun.cn/common/advertising';
			}
		}
	};
</script>
<style scoped lang="scss">
	::v-deep .el-checkbox__input {
		border-radius: 50%;
		border-color: #009944;
		color: #FFFFFF;
	}

	::v-deep .is-checked {
		border-radius: 50%;
		border-color: #009944;
		color: #FFFFFF;
	}

	::v-deep .el-checkbox__inner {
		border-radius: 50%;
		border-color: #009944;
		color: #FFFFFF;
	}

	::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
		border-color: #009944;
		background-color: #009944;
		color: #FFFFFF;
	}

	::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #333333;
	}

	::v-deep .el-checkbox {
		color: #333333;
	}

	::v-deep .el-dialog {
		border-radius: 10px;
	}

	.userMeetingList {
		// height: 70vh;
		// overflow-y: scroll;
		position: relative;

		.table-meeing {
			padding: 0 10px;

			.el-table {
				height: 600px;
				box-sizing: border-box;

				::v-deep .is-leaf {
					// background: #c22929 !important;
					//  background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
					// background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
					// background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
					// background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
					// background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
					// background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%);
					background: #fafbfd;
					// color: rgba(25,30,36,0.6);
					box-sizing: border-box;
				}

				// ::v-deep .el-table__row .cell {
				//     overflow: hidden;
				//     white-space: nowrap;
				//     text-overflow: ellipsis;
				// }
				.el-button {
					color: #2766FF;
					text-align: justify;
					white-space: break-spaces;
					word-break: break-all;
					// margin-right: 15px;
					margin-left: 0;

					::v-deep span:hover {
						border-bottom: 1px solid #2766FF;
					}
				}
			}
		}

		.meeting-search {
			padding: 20px 0 10px 20px;

		}

		::v-deep .meeting-search .el-input__inner {
			background-color: #F3F4F6;
			border: 0px;
			border-radius: 3px;
		}
	}

	.read {
		text-align: center;
		margin-top: 15px;

		.read-content {
			font-weight: bold;
		}
	}

	.dialog-footer {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 10px 0;
	}

	.agreement {
		position: relative;
		color: #282D30;

		.title {
			font-weight: normal;
			font-size: 14px;
			margin-bottom: 0px;

		}

		.tips {
			font-weight: bold;
			margin-top: 20px;
			margin-bottom: 5px;
		}

		p {
			padding:0;
			margin: 0;
			line-height: 28px;
		}
	}
	.img-wrapper {
		background-color: #FFFFFF;
		padding:0 15px 15px;
		box-sizing: border-box;
		position: relative;

		&>img {
			width: 100%;
			border-radius: 4px;
		}

		.banner-btn {
			width: 12%;
			height: 36%;
			position: absolute;
			// border: 1px solid black;
			right: 4%;
			bottom: 30%;
			cursor: pointer;
		}
	}
</style>